function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsp1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.945,
    cy: 151.472,
    rx: 56.129,
    ry: 8.528,
    style: {
      fill: "#061437",
      fillOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.211 121.282c.453.165.93.249 1.412.249 2.265 0 4.128-1.863 4.128-4.128s-1.863-4.128-4.128-4.128c-.29 0-.579.031-.862.091l.103 2.124-1.006-1.82a4.117 4.117 0 0 0-2.356 3.44 4.137 4.137 0 0 0 2.709 4.172Z",
    style: {
      fill: "#57b894",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.184 145.924c-.355-1.807 1.183-3.409 2.702-4.45 1.519-1.041 3.293-2.064 3.811-3.831.745-2.54-1.473-4.865-3.2-6.87a24.846 24.846 0 0 1-3.277-4.871c-.36-.701-.69-1.434-.784-2.215-.136-1.126.225-2.246.59-3.32a240.699 240.699 0 0 1 3.893-10.64",
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.381 120.735c.453.165.93.249 1.412.249 2.265 0 4.128-1.863 4.128-4.128s-1.863-4.128-4.128-4.128c-.29 0-.579.031-.862.091l.103 2.124-1.006-1.82a4.117 4.117 0 0 0-2.356 3.44 4.137 4.137 0 0 0 2.709 4.172Z",
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 108.993a4.126 4.126 0 0 1 2.97-2.618l.34 2.02.63-2.121c2.241.033 4.067 1.885 4.067 4.127 0 2.264-1.863 4.127-4.127 4.127s-4.127-1.863-4.127-4.127c0-.48.083-.957.247-1.408Z",
    style: {
      fill: "#57b894",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.906 108.264a4.128 4.128 0 0 1 2.971-2.618l.34 2.02.63-2.121c2.241.033 4.067 1.885 4.067 4.127 0 2.264-1.863 4.127-4.127 4.127s-4.127-1.863-4.127-4.127c0-.48.083-.957.247-1.408h-.001Z",
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.772 130.813c.453.165.931.249 1.413.249 2.264 0 4.127-1.863 4.127-4.127a4.133 4.133 0 0 0-1.886-3.465l-.485 1.63-.343-2.043a4.13 4.13 0 0 0-1.479-.274c-2.265 0-4.128 1.863-4.128 4.128a4.137 4.137 0 0 0 2.781 3.902Z",
    style: {
      fill: "#57b894",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.968 130.074c.453.165.931.249 1.413.249 2.264 0 4.127-1.863 4.127-4.127a4.133 4.133 0 0 0-1.886-3.465l-.484 1.63-.344-2.043a4.13 4.13 0 0 0-1.479-.274c-2.265 0-4.128 1.863-4.128 4.128a4.137 4.137 0 0 0 2.781 3.902Z",
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.475 137.668a4.14 4.14 0 0 0 4.064 3.413c2.263 0 4.126-1.863 4.126-4.126 0-2.264-1.863-4.126-4.126-4.126a4.128 4.128 0 0 0-3.268 1.607l1.839 2.768-2.513-1.47a4.089 4.089 0 0 0-.122 1.934Z",
    style: {
      fill: "#57b894",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.645 137.121a4.14 4.14 0 0 0 4.064 3.413c2.263 0 4.126-1.863 4.126-4.126 0-2.264-1.863-4.126-4.126-4.126a4.128 4.128 0 0 0-3.268 1.607l1.839 2.768-2.513-1.47a4.089 4.089 0 0 0-.122 1.934Z",
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.112 29.479c.321-6.126 5.45-10.992 11.584-10.992.349 0 .698.016 1.046.047a15.429 15.429 0 0 1 13.324-7.666c5.478 0 10.56 2.921 13.317 7.654.29-.022.583-.037.88-.037 6.135 0 11.263 4.867 11.584 10.994",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.528 28.586c.322-6.126 5.45-10.991 11.584-10.991.349 0 .698.016 1.046.047a15.429 15.429 0 0 1 13.324-7.666c5.478 0 10.559 2.92 13.317 7.653.29-.022.583-.036.88-.036 6.135 0 11.263 4.867 11.584 10.993",
    style: {
      fill: "none",
      stroke: "#061437",
      strokeOpacity: 0.36,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.82 84.616c.321-6.126 5.45-10.992 11.584-10.992.349 0 .698.016 1.046.047a15.429 15.429 0 0 1 13.324-7.666c5.478 0 10.56 2.921 13.317 7.654.29-.022.583-.037.88-.037 6.135.001 11.263 4.868 11.583 10.994",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.236 83.723c.322-6.126 5.45-10.991 11.584-10.991.349 0 .698.016 1.046.047a15.429 15.429 0 0 1 13.324-7.666c5.478 0 10.559 2.92 13.317 7.653.29-.022.583-.036.88-.036 6.134.001 11.262 4.867 11.583 10.993",
    style: {
      fill: "none",
      stroke: "#061437",
      strokeOpacity: 0.36,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.227 26.504c.321-6.126 5.45-10.992 11.584-10.992.349 0 .698.016 1.045.047a15.429 15.429 0 0 1 13.324-7.666c5.478 0 10.56 2.921 13.317 7.654.291-.022.584-.037.88-.037 6.135 0 11.263 4.867 11.584 10.994",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.643 25.611c.322-6.126 5.45-10.991 11.584-10.991.349 0 .698.016 1.045.047A15.427 15.427 0 0 1 110.597 7c5.478 0 10.56 2.92 13.317 7.654.29-.022.583-.036.879-.036 6.134 0 11.262 4.866 11.584 10.992",
    style: {
      fill: "none",
      stroke: "#061437",
      strokeOpacity: 0.36,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.258 50.033s20.848 10.353 24.586 8.915c3.739-1.438 5.033-14.235 5.033-14.235l-15.385-2.876-14.234 8.196Z",
    style: {
      fill: "#ff4d3c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.258 50.033s20.848 10.353 24.586 8.915c3.739-1.438 5.033-14.235 5.033-14.235l-15.385-2.876-14.234 8.196Z",
    style: {
      fillOpacity: 0.1,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff6584",
      fillRule: "nonzero"
    },
    d: "M162.805 34.576h13.66V46.51h-13.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 0.1,
      fillRule: "nonzero"
    },
    d: "M162.805 34.576h13.66V46.51h-13.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.368 85.404s-.576 12.51 3.307 12.222c3.882-.287 0-11.79 0-11.79l-3.307-.432Zm15.96-49.03s.862 5.463-.72 6.182c-1.58.72-2.587 1.294-2.587 1.294l3.594 2.445 6.614.431 1.726-1.294 1.582-1.438s-2.589-.575-2.589-1.869-.143-5.176-.143-5.176l-7.477-.575Z",
    style: {
      fill: "#fbbebe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.328 36.374s.862 5.463-.72 6.182c-1.58.72-2.587 1.294-2.587 1.294l3.594 2.445 6.614.431 1.726-1.294 1.582-1.438s-2.589-.575-2.589-1.869-.143-5.176-.143-5.176l-7.477-.575Z",
    style: {
      fillOpacity: 0.1,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.269 87.561s-4.17 13.372-4.17 23.15c0 0-6.901 15.529-6.614 23.15l-1.725 10.496 2.444.862 1.87-1.581s.575-5.608 2.444-8.34 6.183-15.673 6.183-15.673 11.502-24.155 11.071-27.605c-.431-3.451-11.503-4.458-11.503-4.458v-.001Zm25.45-3.019s2.732 1.294-1.15 24.3c0 0 2.157 15.24.288 23.58l-.288 8.34h-3.02l-.575-.863s-.143-7.477-1.15-9.49c-1.006-2.013-1.87-13.66-1.87-13.66s-4.6-23.724-3.594-25.737c1.007-2.013 11.36-6.47 11.36-6.47h-.001Z",
    style: {
      fill: "#fbbebe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.328 141.912s1.007 2.3 2.876 1.726c1.869-.574 2.3-.575 2.3-.575s-1.293 6.614-.862 9.777c.431 3.163-.287 5.176-3.163 5.176s-3.307-3.45-3.307-3.45l1.294-8.196.862-4.458Zm33.071-3.594s1.007 2.013 2.588 1.581c1.582-.431 2.157-1.15 2.157-1.15s-.144 4.457.432 6.47c.575 2.013 1.869 7.765-1.15 8.052a3.891 3.891 0 0 1-4.027-2.3v-12.653Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.21,
    cy: 33.785,
    r: 6.327,
    style: {
      fill: "#fbbebe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.857 45.145s-5.012-1.968-6.82-1.703a7.392 7.392 0 0 1-5.69 1.703c-3.45-.432-4.8-2.088-4.8-2.088s-9.29 2.088-8.716 2.95c.574.862 3.164 14.954 3.164 14.954s1.725 12.222-.288 16.391c-2.013 4.17-3.02 11.072-2.157 11.647.863.575 10.497 3.163 11.647 3.882 1.15.72 1.582-1.725 2.3-1.294.72.432 2.301 1.15 3.308.575 1.006-.575 10.784-5.751 10.496-6.758-.288-1.006-4.026-13.228-5.32-15.672-1.294-2.444-.288-7.62.431-8.627.72-1.007 2.157-2.157 2.445-5.033.287-2.875 0-10.927 0-10.927Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.148 45.563s-1.18.876-1.61 2.745c-.432 1.869-1.007 16.823-1.007 16.823s-5.32 20.561-4.17 20.992c1.15.432 4.457 1.295 4.889.863.431-.431 5.32-17.83 4.888-19.698-.432-1.868.576-7.334.576-7.334l-3.566-14.391Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.719 72.32s-7.764-3.882-8.627-1.294c-.863 2.588 8.196 5.32 8.196 5.32s3.163-1.15 3.163-1.87c0-.718-2.732-2.156-2.732-2.156Z",
    style: {
      fill: "#fbbebe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.275 45.72 1.582-.575s.862-.576 1.869 1.581c1.006 2.157 11.934 14.81 9.921 18.836-2.013 4.026-8.627 12.222-8.915 11.647-.287-.575-3.594-4.889-3.02-5.32.574-.431 7.19-6.327 6.327-7.19-.863-.863-4.457-8.195-6.47-8.483-2.013-.288-1.294-10.496-1.294-10.496Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.236 33.57s-21.925-8.816-40.905-17.3c0 0-9.921-2.444-15.097 2.157 0 0 4.313-.575 4.313 1.87 0 0 3.739 4.888-7.908 5.75-8.111.602-11.34 5.457-12.554 8.349a11.755 11.755 0 0 1-4.751 5.587c-2.804 1.675-6.867 2.907-11.596.731 0 0 .269.413.779 1.102 9.13 12.33 43.134 23.063 55.141 13.51 7.42-5.903 19.185-13.365 27.618-9.606 13.228 5.895 15.672 3.307 15.672 3.307l.576-1.582s-12.797-3.45-13.085-7.908c-.288-4.457 1.797-5.967 1.797-5.967Zm12.797 1.15s3.092 1.222 3.667 5.248c0 0 3.307 6.47-.432 8.052-3.739 1.582-4.457 1.15-4.457 1.15v-.718s4.026-2.445 3.163-4.314c-.863-1.869-1.94-9.418-1.94-9.418h-.001Z",
    style: {
      fill: "#ff4d3c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.498 53.053s1.006-2.588.718-2.588c-.287 0 1.17-1.592 1.736-1.012.566.58 1.572 2.306.421 2.737-1.15.431-2.875.863-2.875.863Zm7.086-1.537s-2.629-.896-2.616-.608c.012.287-1.64-1.102-1.084-1.691.555-.59 2.237-1.668 2.716-.537.48 1.13.984 2.836.984 2.836Z",
    style: {
      fill: "#ff4d3c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.373 47.589s1.313-.737 2.095.422c.781 1.16-.944 3.173-2.095 3.173-1.15 0-1.15-2.445-1.15-2.445l1.15-1.15Z",
    style: {
      fill: "#ff4d3c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.373 47.589s1.313-.737 2.095.422c.781 1.16-.944 3.173-2.095 3.173-1.15 0-1.15-2.445-1.15-2.445l1.15-1.15Z",
    style: {
      fillOpacity: 0.1,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.725 23.461c-.758.625-1.477 1.326-1.949 2.188a9.801 9.801 0 0 0-.618 1.504c-.581 1.673-2.026 3.368-1.415 5.03.175.475.447.975.29 1.456-.138.427-.567.676-.878 1-.665.697-.777 1.742-.818 2.704-.074 1.763.895 3.841 2.066 5.16.255.249.49.516.705.799.293.456.374 1.019.221 1.539l1.706-.357c.062.63.081 1.264.058 1.896a1.776 1.776 0 0 0 1.877-1.213c.096.451.254.887.468 1.296a6.673 6.673 0 0 0 1.134-2.1 6.007 6.007 0 0 0 .203-3.03 12.888 12.888 0 0 0-.734-2.153c-.603-1.524-1.096-3.089-1.587-4.652-.256-.812-.514-1.65-.437-2.498l.606-.065c.007-.335.072-.666.192-.979.355.075.697.204 1.014.382l.699-1.774c.46.478 1.123.695 1.757.895l2.41.758.014-.477c1.017.9 2.175 1.627 3.429 2.151a.782.782 0 0 1-.17-.62c.594 1.063.357 2.388-.01 3.55-.366 1.162-.852 2.345-.705 3.554.11.904.574 1.77.488 2.676-.042.447-.217.872-.271 1.317-.13 1.062.428 2.074.968 2.998l1.048-1.44c.384-.526.779-1.065 1.322-1.425.558-.37 1.249-.535 1.735-.995.867-.821.757-2.22.475-3.38-.15-.617-.331-1.243-.276-1.875.093-1.073.838-1.96 1.258-2.95a5.126 5.126 0 0 0-.287-4.504c-.52-.893-1.307-1.612-1.798-2.522-.489-.906-.675-1.984-1.344-2.766a4.655 4.655 0 0 0-1.127-.897 14.69 14.69 0 0 0-6.249-2.039c-2.096-.219-3.864.534-5.47 1.858Z",
    style: {
      fill: "#585ddb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h320v160H0z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsp1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/usp1.9795baa83b7ef63f756e681247661123.svg";